// Multivariate Dependencies
import React, { useRef, useState, useEffect, useCallback } from 'react';
// Components
import { PopupMechanism } from '../../../common/components/PopupMechanism';
import { Container } from '../../../common/styles/container';
import { Paragraph } from '../../../atoms/Paragraph';
import { TooltipContainer } from '../styles/TooltipContainer';
// Utils
import { openTooltipHandler, closeTooltipHandler } from '../utils/tooltipOpenStateHandlers';
import { ZIndex } from '../../../common/types/ZIndex';
import { TooltipStylePropertiesBySize } from '../types/TooltipStylePropertiesBySize';
import { TooltipConfig } from '../types/TooltipConfig';
// Hooks
import { useTheme } from 'styled-components';
export var TooltipStructure = function (_a) {
    var children = _a.children, placement = _a.placement, alignment = _a.alignment, size = _a.size, content = _a.content, _b = _a.hasArrow, hasArrow = _b === void 0 ? true : _b, disabled = _a.disabled, className = _a.className, _c = _a.openAfterDelay, openAfterDelay = _c === void 0 ? 0 : _c, _d = _a.closeAfterDelay, closeAfterDelay = _d === void 0 ? false : _d;
    var themeStyles = useTheme();
    var targetedElementRef = useRef();
    var isMountedRef = useRef(true);
    var _e = useState(false), tooltipOpen = _e[0], setTooltipOpen = _e[1];
    var _f = TooltipStylePropertiesBySize[size], maxWidth = _f.maxWidth, padding = _f.padding;
    // Ensures we do not get a no-op error when trying to set state after unmount
    var setTooltipOpenStateIfMounted = useCallback(function (isOpen) {
        if (isMountedRef.current) {
            setTooltipOpen(isOpen);
        }
    }, []);
    useEffect(function () {
        isMountedRef.current = true;
        var keydownEventListener = function (e) {
            if (e.key === 'Escape') {
                closeTooltipHandler(0, setTooltipOpenStateIfMounted);
            }
        };
        var scrollEventListener = function () {
            closeTooltipHandler(0, setTooltipOpenStateIfMounted);
        };
        window.addEventListener('keydown', keydownEventListener);
        window.addEventListener('scroll', scrollEventListener, { capture: true });
        return function () {
            window.removeEventListener('keydown', keydownEventListener);
            window.removeEventListener('scrollEventListener', scrollEventListener, { capture: true });
            isMountedRef.current = false;
        };
    }, [setTooltipOpenStateIfMounted]);
    if (disabled)
        return children;
    return (
    // This div is required to be able to display tooltips on disabled elements / children
    // This is because disabled elements disable all events from firing
    React.createElement(React.Fragment, null,
        React.createElement(Container, { className: className, ref: targetedElementRef, lineHeight: '0', onMouseEnter: function () {
                openTooltipHandler(openAfterDelay, setTooltipOpenStateIfMounted);
            }, onMouseLeave: function () {
                closeTooltipHandler(closeAfterDelay ? TooltipConfig.timeToWaitBeforeClosingTooltip : 0, setTooltipOpenStateIfMounted);
            } }, children),
        tooltipOpen && (React.createElement(PopupMechanism, { targetedElement: targetedElementRef, placement: placement, spaceBetweenElement: hasArrow ? 7 : 0, alignToTargetedElement: alignment !== null && alignment !== void 0 ? alignment : 'center' },
            React.createElement(TooltipContainer, { role: 'tooltip', zIndex: ZIndex.TOOLTIP, padding: padding, backgroundColor: themeStyles.backgroundUI, borderRadius: '4px', placement: placement, boxSizing: 'border-box', boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.24)', display: 'grid', justifyContent: 'start', width: 'max-content', maxWidth: maxWidth, hasArrow: hasArrow, onMouseEnter: function () {
                    if (closeAfterDelay) {
                        openTooltipHandler(openAfterDelay, setTooltipOpenStateIfMounted);
                    }
                }, onMouseLeave: function () {
                    closeTooltipHandler(closeAfterDelay ? TooltipConfig.timeToWaitBeforeClosingTooltip : 0, setTooltipOpenStateIfMounted);
                } }, typeof content === 'string' ? React.createElement(Paragraph, { size: 'small' }, content) : content)))));
};
//# sourceMappingURL=TooltipStructure.js.map